import { gridIdList } from '@ad-lucy/components/layout/Grid/constants';
import { createCombinedGridMap } from '@ad-lucy/components/layout/Grid/createCombinedGridMap';
import { useCreativesConfig } from '@ad-lucy/context';
import { useMemo } from 'react';

export const useCombinedGridMap = () => {
  const { grid } = useCreativesConfig();
  const nameList = grid.grids;

  return useMemo(() => createCombinedGridMap(nameList, gridIdList), [nameList]);
};
